import useTranslation from '@space-lib/hooks/useTranslation'
import styled from 'styled-components'

const Title = styled.h3`
  font-size: 1.125rem;
`

const CourseHeader = () => {
  const { t } = useTranslation()

  return (
    <>
      <Title className='_font-weight-bold _text-gray-900 _mb-1'>
        {t('configuration_sidebar.access_and_privacy.associate_course.title')}
      </Title>
      <p className='_font-weight _text-gray-500'>
        {t('configuration_sidebar.access_and_privacy.associate_course.description')}
      </p>
    </>
  )
}

export default CourseHeader
